<div class="song" [class.song_status_playing]="melody.isPlaying">
  <div class="song__cover">
    <img [src]="melody.pictureUrlSmall" [alt]="melody.title + ', ' + melody.artistTitle"/>
    <div class="song__player" *ngIf="melody.mp3Path" (click)="play()">
      <div class="player player_size_">
        <div class="player__button icon-play" [class.icon-pause]="melody.isPlaying"></div>
        <div class="player__progressbar" #progressBar></div>
      </div>
    </div>
  </div>
  <div class="song__content song__content-more">
    <div class="song__name">
      <a *ngIf="melody.melodyMarketplaceId && showControls" [routerLink]="'/melodies/' + melody.melodyMarketplaceId" class="song__name-link">{{ melody.title }}</a>
      <span *ngIf="!melody.melodyMarketplaceId || !showControls" class="song__name-link">{{ melody.title }}</span>
    </div>
    <div class="song__artist" *ngIf="melody.artistTitle">
      <a *ngIf="melody.artistId && showControls" [routerLink]="'/artists/' + melody.artistId" class="song__artist-link">{{ melody.artistTitle }}</a>
      <span *ngIf="!melody.artistId || !showControls" class="song__artist-link">{{ melody.artistTitle }}</span>
    </div>
    <div class="song__gift" *ngIf="melody.msisdnDonator != null && melody.tariffType === 'PROMO' ">
      <div class="song__gift-icon">
        <div class="icon icon-gift"></div>
      </div>
      <div class="song__gift-number">от {{ formattedDonatorPhone() }}</div>
<!--      <div class="song__gift-date" *ngIf="(melody.paidFrom && showDateEndPromo)">до {{ getPaidToDate(melody.paidFrom) | date:'dd.MM.yy' }}</div>-->
    </div>
  </div>
  <div class="song__more-controls" *ngIf="showControls">
    <div class="song__more-controls-trigger icon icon-more" (click)="openSettings()"></div>
  </div>
</div>
